module.exports = __webpack_public_path__ + "static/media/marker_address.c830a5ff.svg";